(function () {
  var cfg = window.__highlightConfig || {};
  if (!cfg.collectionUrl || !cfg.filterParam) return;

  var LIST = '#collection';

  function sectionIdOf(list) {
    var sec = list.closest('[id^="shopify-section-"]');
    return sec ? sec.id.replace('shopify-section-', '') : null;
  }

  function matchesRule(card, handle) {
    if (card.getAttribute('data-highlight-enabled') !== 'true') return false;
    var cols = (card.getAttribute('data-highlight-collections') || '').trim();
    if (cols === '') return true; // aucune collection → partout
    return cols.split(',').map(function (s) { return s.trim(); }).indexOf(handle) !== -1;
  }

  function addBadge(card) {
    if (!cfg.showBadge || !cfg.badgeLabel) return;
    var fig = card.querySelector('figure');
    if (!fig || fig.querySelector('.highlight-badge')) return; // évite le doublon
    var badge = document.createElement('span');
    badge.className = 'highlight-badge';
    badge.textContent = cfg.badgeLabel;
    fig.insertBefore(badge, fig.firstChild);
  }

  function run() {
    var list = document.querySelector(LIST);
    if (!list) return;

    var sectionId = sectionIdOf(list);
    var url = cfg.collectionUrl + '?' + cfg.filterParam +
      (sectionId ? '&section_id=' + encodeURIComponent(sectionId) : '');

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fetched = doc.querySelector(LIST);
        if (!fetched) return;

        var cards = Array.prototype.slice.call(fetched.querySelectorAll(':scope > li.product-card'));
        var keep = cards.filter(function (c) { return matchesRule(c, cfg.collectionHandle); });
        if (!keep.length) return;

        var frag = document.createDocumentFragment();
        keep.forEach(function (card) {
          card.setAttribute('data-highlight', 'true');
          addBadge(card);
          var pid = card.getAttribute('data-product-id');
          if (pid) {
            var dup = list.querySelector(':scope > li[data-product-id="' + pid + '"]');
            if (dup) dup.parentNode.removeChild(dup);
          }
          frag.appendChild(card);
        });
        list.insertBefore(frag, list.firstElementChild);

        // Pastilles couleur des cartes ajoutées : même limite « +N » que les autres cartes, dès l'affichage
        // (sinon elles restent toutes visibles jusqu'au prochain chargement de produits)
        if (typeof window.check_limit_event === 'function') window.check_limit_event();

        // Bouton « Aperçu » des cartes ajoutées : si le script du thème (custom-async.js) est déjà chargé, son
        // QuickView est déjà initialisé et ne les connaît pas (le clic ouvrait la page produit). init() ne traite
        // que les boutons pas encore branchés (:not(.quickshop-initialized)). Sinon, le thème les branchera à son chargement.
        if (window.quickShop && typeof window.quickShop.init === 'function') window.quickShop.init();

        window.dispatchEvent(new Event('resize'));
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();